import React, { useEffect, useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import ReactTable from "components/Tables/ReactTable.js";
import Button from "components/CustomButtons/Button";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import TableHeader from "components/Tables/TableHeader";
import { useHistory, useLocation, useParams } from "react-router-dom";
import useAxios from "axios/httpService";
import { apiErrorHandler } from "helpers/apiErrorHandler";
import Loading from "components/Loading/Loading";
import { GetAllDocumentForInquiryUrl } from "axios/commonAPIsUrls";
import jwtDecode from "jwt-decode";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },
  mtZero: {
    marginTop: "0px",
  },
  ptZero: {
    paddingTop: "0px !important",
  },
};

const useStyles = makeStyles(styles);
const Documents = () => {
  const history = useHistory();
  const pageSize = 8;
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);

  const { inquiryId } = useParams();

  const token = localStorage.getItem("token");
  const [
    { data: inquiryDocuments, error, loading },
    ExecuteGetAllDOcumentsUrl,
  ] = useAxios(
    GetAllDocumentForInquiryUrl(inquiryId, currentPage, pageSize, token),
    {
      manual: true,
    }
  );

  useEffect(() => {
    ExecuteGetAllDOcumentsUrl(currentPage);
  }, [currentPage]);
  useEffect(() => {
    if (inquiryDocuments) {
      setData(
        inquiryDocuments.data.map((prop, key) => {
          return {
            id: prop.Id,
            documentName: prop.DocumentName,
            actions: (
              <div className="actions-center">
                <Button
                  justIcon
                  round
                  simple
                  size="sm"
                  color="primary"
                  action
                  tooltipText="Download Document"
                  onClick={() => window.open(prop.path)}
                >
                  <i className="fa fa-sm fa-download" />
                </Button>
              </div>
            ),
          };
        })
      );
    }
  }, [inquiryDocuments]);

  const classes = useStyles();

  const columns = [
    {
      Header: "Document Name",
      accessor: "documentName",
      alignment: "center",
    },
    {
      Header: (
        <div
          style={{
            textAlign: "center",
          }}
        >
          Actions
        </div>
      ),
      accessor: "actions",
      alignment: "center",
    },
  ];

  // ERROR HANDLING
  if (error) {
    apiErrorHandler(error, history);
  }

  if (loading) {
    return <Loading loading />;
  }
  const decodedToken = jwtDecode(token);
  let loggedInRole = null;
  if (decodedToken.role.toLowerCase() === "superadmin") {
    loggedInRole = "superAdmin";
  } else if (decodedToken.role.toLowerCase() === "customeradmin") {
    loggedInRole = "customerAdmin";
  }

  return (
    <GridContainer className={classes.center}>
      <GridItem xs={12}>
        <Card>
          <CardHeader>
            <TableHeader
              title="Tools"
              showBackButton
              goBackRoute={`/${loggedInRole}/dashboard/view-insights/${inquiryId}/overview`}
            />
          </CardHeader>
          <CardBody>
            <ReactTable
              columns={columns}
              data={data}
              loading={loading}
              currentPage={inquiryDocuments && inquiryDocuments.currentPage}
              defaultPageSize={inquiryDocuments && inquiryDocuments.pageSize}
              totalItems={inquiryDocuments && inquiryDocuments.totalItem}
              totalPages={inquiryDocuments && inquiryDocuments.totalPage}
              setCurrentPage={setCurrentPage}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default Documents;
